export default __webpack_public_path__ + "static/media/xls.1545997f.svg";